<template>
  <div class="city-select-page qm-page-bg">
    <van-nav-bar
      left-arrow
      title="选择城市"
      class="qm-nav-bar"
      @click-left="onClickLeft"
    />
    <div class="search-hint">滑动右侧字母快速定位</div>
    <div class="city-list">
      <van-index-bar :index-list="indexList">
        <div v-for="(cities, letter) in groupedCities" :key="letter">
          <van-index-anchor :index="letter" />
          <van-cell v-for="city in cities" :key="city.code" :title="city.city" @click="selectCity(city.city)" />
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
import areaData from '@/assets/area.json'

// 城市配置
const CITY_CONFIG = {
  enableAllCities: false, // 是否启用所有城市
  enabledProvinces: ['广东省', '福建省'] // 启用的省份列表
}

export default {
  name: 'CitySelector',
  data() {
    return {
      activeTab: 0,
      indexList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
      groupedCities: this.groupCitiesByInitial(this.filterCities(areaData.cityList))
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    selectCity(city) {
      if (this.isCityEnabled(city)) {
        // Here you would typically store the selected city in Vuex or emit an event
        this.$router.back()
      } else {
        this.$toast('暂不支持该城市')
      }
    },
    groupCitiesByInitial(cityList) {
      const grouped = {}
      this.indexList.forEach(letter => {
        const cities = cityList.filter(city => city.initial === letter);
        if (cities.length > 0) {
            grouped[letter] = cities;
        }
      })
      return grouped
    },
    filterCities(cityList) {
      if (CITY_CONFIG.enableAllCities) {
        return cityList
      }
      return cityList.filter(city => this.isCityEnabled(city.city))
    },
    isCityEnabled(cityName) {
      if (CITY_CONFIG.enableAllCities) {
        return true
      }
      return CITY_CONFIG.enabledProvinces.some(province => {
        return areaData.cityList.some(city => 
          city.city === cityName && 
          city.province === province
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.city-select-page {
  min-height: 100vh;
}

.search-hint {
  text-align: center;
  font-size: 12px;
  color: var(--qm-text-muted);
  padding: 8px 16px 12px;
}

.city-list {
  :deep(.van-cell) {
    color: var(--qm-text-primary);
    background: transparent;

    &::after {
      border-color: var(--qm-border);
    }

    &:active {
      background: var(--qm-bg-card-hover);
    }
  }
}
</style> 